// Image validation utilities for landing page builder

export const IMAGE_REQUIREMENTS = {
  logo: {
    maxWidth: 400,
    maxHeight: 200,
    minAspect: 1, // width/height ratio
    maxAspect: 4,
    maxSizeMB: 5,
    allowedTypes: ['image/jpeg', 'image/png', 'image/webp', 'image/jpg'],
  },
  banner: {
    maxWidth: 2500,
    maxHeight: 1200,
    minAspect: 1.5,
    maxAspect: 3,
    maxSizeMB: 10,
    allowedTypes: ['image/jpeg', 'image/png', 'image/webp', 'image/jpg'],
  },
};

export const validateImageFile = (file, type = 'logo') => {
  const errors = [];
  const requirements = IMAGE_REQUIREMENTS[type];
  
  if (!requirements) {
    return ['Unknown image type'];
  }

  // Check file size
  const maxSizeBytes = requirements.maxSizeMB * 1024 * 1024;
  if (file.size > maxSizeBytes) {
    errors.push(`File too large. Max ${requirements.maxSizeMB}MB allowed.`);
  }

  // Check file type
  if (!requirements.allowedTypes.includes(file.type)) {
    errors.push(`Invalid format. Use JPG, PNG, or WebP.`);
  }

  return errors;
};

export const validateImageDimensions = (img, type = 'logo') => {
  const errors = [];
  const requirements = IMAGE_REQUIREMENTS[type];
  
  if (!requirements) return errors;

  // Check dimensions
  if (img.width > requirements.maxWidth) {
    errors.push(`Width too large. Max ${requirements.maxWidth}px allowed.`);
  }
  if (img.height > requirements.maxHeight) {
    errors.push(`Height too large. Max ${requirements.maxHeight}px allowed.`);
  }

  // Check aspect ratio
  const aspect = img.width / img.height;
  if (aspect < requirements.minAspect || aspect > requirements.maxAspect) {
    errors.push(
      `Aspect ratio should be between ${requirements.minAspect}:1 and ${requirements.maxAspect}:1`
    );
  }

  return errors;
};

export const getImagePreview = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => resolve(e.target.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
};

export const checkImageDimensions = (file) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const objectUrl = URL.createObjectURL(file);
    
    img.onload = () => {
      resolve({ width: img.width, height: img.height });
      URL.revokeObjectURL(objectUrl);
    };
    img.onerror = (err) => {
      URL.revokeObjectURL(objectUrl);
      reject(err);
    };
    img.src = objectUrl;
  });
};